import { styled } from "@mui/system";

export const StyledAppBar = styled("div")({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
});
